<template>
    <div class="app app-tenants">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name: 'tenants-container',
        components: {

        },
        data() {
            return {

            }
        },
        computed: {

        },
        watch: {
            $route: {
                immediate: true,
                handler(to) {
                    document.title = to.meta.title || 'Loading...';
                }
            },
        },
        async created() {

        },
        methods: {
        },
    }
</script>
